import { createTable2PopoverPlugin } from './popover'
import { createTable2ColumnWidthByCellContent } from './cell-content-width'
import { createBatchCheckboxDragSelect } from './batch-checkbox-drag-select'

export function table2Plugins () {
  const pluginTasks = [
    createTable2PopoverPlugin,
    createTable2ColumnWidthByCellContent,
    // 鼠标左键按下支持表格多选勾选
    createBatchCheckboxDragSelect
  ]
  let initializedPlugins = []
  // 插件注册
  const register = (vm) => {
    initializedPlugins = pluginTasks.map(task => task(vm))
  }
  // 插件销毁
  const destroy = () => {
    initializedPlugins.forEach(plugin => {
      if (typeof plugin.destroy === 'function') {
        plugin.destroy()
      }
    })
    initializedPlugins = []
  }
  return {
    register,
    destroy
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/plugins/index.js